import { render, staticRenderFns } from "./AddColor.vue?vue&type=template&id=36e0c17c&scoped=true"
import script from "./AddColor.vue?vue&type=script&lang=js"
export * from "./AddColor.vue?vue&type=script&lang=js"
import style0 from "./AddColor.vue?vue&type=style&index=0&id=36e0c17c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0c17c",
  null
  
)

export default component.exports